export function useNotificationTapHandler() {
  return undefined
}
